import React from "react";

import classes from "./styles.module.scss";

const NoAnalysisWereRun = () => {
    return (
        <div className={classes.noAnalysisWereRunContainer}>
            <h3>No results to display!</h3>
            <p>Run an analysis to see the results.</p>
        </div>
    );
};

export default NoAnalysisWereRun;
